export default __webpack_public_path__ + "static/media/GR00050-backdrop_activity.8c50bfd3.svg";